import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { HeaderNavigationItemModule } from '../../components/header-navigation-item';
import { MenuLoginComponent } from './menu-login.component';

@NgModule({
  declarations: [MenuLoginComponent],
  imports: [
    NzIconModule,
    CommonModule,
    I18nModule,
    UrlModule,
    HeaderNavigationItemModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MenuLoginComponent: {
          component: MenuLoginComponent,
        },
      },
    }),
  ],
  providers: [],
  exports: [MenuLoginComponent],
})
export class MenuLoginModule {}
